import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DocumentsServe } from 'src/app/utils/constants';
import { SeoData } from '../../../utils/models';

@Injectable()
export class SeoService {
  description: any;

  constructor(private title: Title, private meta: Meta) {
    this.description = '';
  }

  updateSeo(data: SeoData) {

    //console.log("Vicman:: Ingreso a updateSeo", data);

    this.title.setTitle(data.nombre);


    // if (data.empresa !== '') {
    //   this.description = data.empresa;
    // } else {
    //   this.description = data.descripcion;
    // }

    // this.meta.updateTag({ name: 'title', content: data.nombre });
    // this.meta.updateTag({ name: 'description', content: data.descripcion });
    // this.meta.updateTag({ name: 'url', content: data.url });
    // this.meta.updateTag(
    //   { property: 'og:title', content: data.nombre },
    //   "property='og:title'"
    // );
    // this.meta.updateTag(
    //   { property: 'og:description', content: data.descripcion },
    //   "property='og:description'"
    // );
    // this.meta.updateTag(
    //   { property: 'og:url', content: data.url },
    //   "property='og:url'"
    // );
    // this.meta.updateTag(
    //   { property: 'og:image', content: data.urlFotoPerfil },
    //   "property='og:image'"
    // );
    // this.meta.updateTag({
    //   property: 'og:image:secure_url',
    //   content: data.urlFotoPerfil,
    // });

    // this.meta.updateTag({ name: 'twitter:text:title', content: data.nombre });
    // this.meta.updateTag({
    //   name: 'twitter:description',
    //   content: data.descripcion,
    // });
    // this.meta.updateTag({ name: 'twitter:url', content: data.url });
    // this.meta.updateTag({ name: 'twitter:image', content: data.urlFotoPerfil });
    
    // { name: 'title', content: data.nombre },

    //console.log("Vicman:: Paso antes meta");

    this.meta.addTags([
      { name: 'title', content: data.nombre },
      { name: 'description', content: data.descripcion },
      { name: 'url', content: data.url },
      { property: 'og:title', content: data.nombre },      
      //{ property: 'og:description', content: data.descripcion },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: data.url },
      { property: 'og:image', content: data.urlFotoPerfil },

      { property: 'og:image:secure_url', content: data.descripcion, itemprop: 'image',},
      
      { property: 'og:image:type', content: 'image/png' },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' },
      { property: 'og:image:width', content: '300' },
      { property: 'og:image:height', content: '300' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: data.nombre },
      { name: 'twitter:description', content: data.descripcion },
      { name: 'twitter:url', content: data.url },
      { name: 'twitter:image', content: data.urlFotoPerfil },
    ]);
    

    // data.nombre = 'Bicho';
    //this.meta.updateTag({ property: 'og:title', content: 'Bicho data.nombre' });
    //this.meta.updateTag({ property: 'og:image', content: data.urlFotoPerfil });
    // this.meta.updateTag({ property: 'og:image', content: data.urlFotoPerfil });
    

    //console.log("Vicman:: Adicionando metadatos", this.meta);

  //   content: data.descripcion },
  //   { property: 'og:type', content: 'website' },
  //   { property: 'og:url', content: data.url },
  //   { property: 'og:image', content: 'https://media.gettyimages.com/id/200244581-003/es/foto/large-crowd-of-people-looking-up-smiling-portrait-elevated-view.jpg?s=612x612&w=gi&k=20&c=rIn5Dk1IlARzJ3EsumG5iOT0VqcI727MeyqQO56ItB0=' },
  //   { name: 'twitter:card', content: 'summary_large_image' },
  //   { name: 'twitter:title', content: data.nombre },
  //   { name: 'twitter:description', content: data.descripcion },
  //   { name: 'twitter:url', content: data.url },
  //   { name: 'twitter:image', content: data.urlFotoPerfil },
  // ]);

}
  

  buildImageSeo(idTarjeta: number, urlImage: string): string {
    return DocumentsServe.COVERPHOTOS + `${idTarjeta}/${urlImage}`;
    // var miUrl = DocumentsServe.COVERPHOTOS + `${idTarjeta}/${urlImage}`;
    // console.log('Vicman:: Seo.Service.ts ' + miUrl );
    // return miUrl;
  }
}
